// @ts-nocheck
import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '@/js/auth.js'

// 引入路由文件
// @ts-ignore
import baseRouter from '@/router/baseRouter'

Vue.use(Router)
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const baseRoutes = []
const routes = baseRoutes.concat(
  // 基础 路由
  baseRouter
)

const router = new Router({
  mode: 'history',
  routes
})
router.beforeEach((to, from, next) => {
  const token = getToken()
  const parentPath = to.matched[0].path
  if (parentPath === '/managementSystem') {
    if (token) {
      next()
    } else {
      router.push({
        path: '/login',
        querry: { redirect: router.currentRoute.fullPath } // 从哪个页面跳转
      })
    }
  } else {
    const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if (flag && to.name === 'index') {
      router.push({
        path: '/mobileindex',
        querry: { redirect: router.currentRoute.fullPath } // 从哪个页面跳转
      })
    } else {
      next()
    }
  }
  // ...
})
export default router
